module.exports = __webpack_public_path__ + "img/logo-right.4b6ceca5.png";